import darkTheme from './dark';
import lightTheme from './light';

export const THEME_STORAGE_KEY = 'chainsight-theme';
export const themeModes = ['light', 'dark'];

const themes = {
  dark: darkTheme,
  light: lightTheme,
};

export function getTheme(mode = 'dark') {
  return themes[mode] ?? themes.dark;
}

export function getColors(mode = 'dark') {
  return getTheme(mode).colors;
}

export function getCssVariables(mode = 'dark') {
  return getTheme(mode).cssVariables;
}

export function resolveSystemTheme() {
  if (typeof window === 'undefined') return 'dark';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function getStoredTheme() {
  if (typeof window === 'undefined') return null;
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  return themeModes.includes(stored) ? stored : null;
}

export function resolveInitialTheme() {
  return getStoredTheme() ?? resolveSystemTheme();
}

export function applyThemeToDocument(mode) {
  if (typeof document === 'undefined') return;
  const resolved = themeModes.includes(mode) ? mode : 'dark';
  const root = document.documentElement;
  const vars = getCssVariables(resolved);

  root.setAttribute('data-theme', resolved);
  root.style.colorScheme = resolved;

  Object.entries(vars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}

export function persistTheme(mode) {
  if (typeof window !== 'undefined' && themeModes.includes(mode)) {
    localStorage.setItem(THEME_STORAGE_KEY, mode);
  }
}

export { darkTheme, lightTheme };
